import useMutationApi from '../../useMutationApi';
import { FieldMappings } from './useWorkflowMapFields';

interface WorkflowApplyMappingsRequest {
  data: string; // Raw preprocessed CSV
  mappings: FieldMappings;
}

interface WorkflowApplyMappingsResponse {
  transformedCSV: string; // Final rebate-ready CSV
  explanations: string[]; // Step-by-step transformation log
}

const useWorkflowApplyMappings = () => {
  return useMutationApi<
    WorkflowApplyMappingsRequest,
    WorkflowApplyMappingsResponse
  >({
    endpoint: 'spreadsheet/workflow/apply-mappings',
    method: 'POST',
    successMessage: 'Mappings applied successfully',
    showSuccessToast: false, // Let the UI handle success feedback
  });
};

export default useWorkflowApplyMappings;
export type { WorkflowApplyMappingsRequest, WorkflowApplyMappingsResponse };
